/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Mandatorytechskills_Placeholder2Inputs */

const en_job_form_mandatorytechskills_placeholder2 = /** @type {(inputs: Job_Form_Mandatorytechskills_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Java, Spring Boot...`)
};

const de_job_form_mandatorytechskills_placeholder2 = /** @type {(inputs: Job_Form_Mandatorytechskills_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Java, Spring Boot…`)
};

/**
* | output |
* | --- |
* | "Java, Spring Boot..." |
*
* @param {Job_Form_Mandatorytechskills_Placeholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_mandatorytechskills_placeholder2 = /** @type {((inputs?: Job_Form_Mandatorytechskills_Placeholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Mandatorytechskills_Placeholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_mandatorytechskills_placeholder2(inputs)
	return en_job_form_mandatorytechskills_placeholder2(inputs)
});
export { job_form_mandatorytechskills_placeholder2 as "job_form_mandatoryTechSkills_placeholder" }